import { createFileRoute, redirect } from '@tanstack/react-router'
import { ApiError } from '~/lib/api'
import { sessionQuery } from '~/lib/session'
import { AppShell } from '~/features/shell/AppShell'

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.ensureQueryData(sessionQuery).catch((e: unknown) => {
      if (e instanceof ApiError && e.status === 401) return null
      throw e
    })
    if (!session) {
      if (location.pathname === '/') throw redirect({ to: '/start' })
      throw redirect({ to: '/login', search: { from: location.href } })
    }
    if (!session.active) throw redirect({ to: '/setup' })
  },
  component: AppShell,
})
